import React, { Component } from 'react';
import { verifyStateAndGetRedirectLocation } from './AuthenticationService';
import { withRouter } from 'react-router-dom';
import FullScreenLoadingComponent from '../Components/Loaders/FullScreenLoadingComponent';

class AuthenticateComponent extends Component {
  async componentDidMount() {
    try {
      const redirectionLocation = await verifyStateAndGetRedirectLocation();
      this.props.history.replace(redirectionLocation);
    } catch (error) {
      // Redirect to home or error page on authentication failure
      this.props.history.replace('/');
    }
  }

  render() {
    return <FullScreenLoadingComponent />;
  }
}
export default withRouter(AuthenticateComponent);



// WEBPACK FOOTER //
// ./src/Authentication/AuthenticateComponent.js